import { MixerHorizontalIcon } from '@radix-ui/react-icons';
import { IconButton } from '@radix-ui/themes';
import { useTranslation } from 'react-i18next';
import { useMatch } from 'react-router-dom';
import { skipToken } from '@reduxjs/toolkit/query';

import {
    ServiceOrderDialog,
    useServiceOrderModal,
} from '@features/serviceOrders';
import { ServiceOrderProvider } from '@features/serviceOrders/context/ServiceOrderContext';
import { DeliveryModal } from '@features/delivery/components/DeliveryModal';

import { AssetDetailsPagePath } from '@router/constants';
import { mapClipToOrderDeliveryItem } from '@features/Clip/utils/mapClipToOrderDeliveryItem';
import { useClipById } from '@features/Clip/hooks/useClipById';

import styles from './Header.module.css';

export const ServiceOrderButton = () => {
    const { t } = useTranslation('serviceOrders');
    const serviceOrder = useServiceOrderModal();

    const match = useMatch(AssetDetailsPagePath);
    const assetId = match?.params?.assetId;

    const { data: currentClip } = useClipById(
        {},
        assetId ? { assetId } : skipToken,
    );

    const handleOpenOrder = () => {
        if (assetId && currentClip) {
            const mappedItem = mapClipToOrderDeliveryItem(currentClip);
            serviceOrder.openServiceOrder([mappedItem]);
        } else {
            serviceOrder.openServiceOrder([]);
        }
    };

    return (
        <>
            <IconButton
                className={styles.settings}
                variant={'ghost'}
                radius={'full'}
                style={{ color: 'inherit', cursor: 'pointer' }}
                onClick={handleOpenOrder}
                title={t('wizard.step1.title')}
            >
                <MixerHorizontalIcon width='20px' height='20px' />
            </IconButton>

            <ServiceOrderProvider value={serviceOrder}>
                <DeliveryModal.Root value={serviceOrder.dialogProps}>
                    <ServiceOrderDialog />
                </DeliveryModal.Root>
            </ServiceOrderProvider>
        </>
    );
};
